import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { IUserSubscriptionHistoryRepository } from "@/domain/repositories/IUserSubscriptionHistoryRepository"
import { IUserSubscriptionHistoryRemoteDataSource } from "../datasources/interfaces/remote/IUserSubscriptionHistoryRemoteDataSource"
import UserSubscriptionHistoryDataMappers from "../mappers/UserSubscriptionHistoryDataMappers"

export class UserSubscriptionHistoryRepository implements IUserSubscriptionHistoryRepository {
    dataSource: IUserSubscriptionHistoryRemoteDataSource
    constructor(dataSource: IUserSubscriptionHistoryRemoteDataSource) {
        this.dataSource = dataSource
    }

    async list(userId: string): Promise<UserSubscriptionTransaction[]> {
        const response = await this.dataSource.list(userId)
        console.log(response)
        return UserSubscriptionHistoryDataMappers.toTransactionList(response.data)
    }
}
